const defaultLocations = [];
const epikBoxLocations = (state = defaultLocations, action) => {
  switch (action.type) {
    case 'EPIK_BOX_LOCATION_SUCCESS':
      return action.epikBoxLocations;
    default:
      return state;
  }
};

export default epikBoxLocations;
